// Webpack Imports
import * as bootstrap from 'bootstrap';
var $ = jQuery.noConflict();
var body = document.body;

window.addEventListener('resize', function() {
    var windowWidth = window.innerWidth;

    if (windowWidth < 1330) {
        if (!body.classList.contains('is--mobile')) {
            body.classList.add('is--mobile');
        }
    } else {
        if (body.classList.contains('is--mobile')) {
            body.classList.remove('is--mobile');
        }
    }
});

// Execute the event listener initially to handle initial window width
window.dispatchEvent(new Event('resize'));

// Adds a "is--sticky" class to <header> on scroll
(function () {
    const primaryHeader = document.querySelector("header");
    const scrollWatcher = document.createElement("div");
    
    scrollWatcher.setAttribute("data-scroll-watcher", "");
    primaryHeader.before(scrollWatcher);
    
    const navObserver = new IntersectionObserver(
        (entries) => {
            primaryHeader.classList.toggle("is--sticky", !entries[0].isIntersecting);
        },
        { rootMargin: "50px 0px 0px 0px" }
    );
    
    navObserver.observe(scrollWatcher);
})();

// DESKTOP NAVIGATION
document.addEventListener('DOMContentLoaded', function () {
    if (!body.classList.contains('is--mobile')) {

    // Select all li elements within the specified path, regardless of .has--children class
    var allLiElements = document.querySelectorAll('body:not(.is--mobile) .header__navigation>nav>ul>li');
    var headerElement = document.querySelector('body:not(.is--mobile) header'); // Assuming there's only one <header> element
    var headerSearchDiv = document.querySelector('body:not(.is--mobile) .header__search');
    var listItems = document.querySelectorAll('body:not(.is--mobile) .dropdown .dropdown__navigation>.dropdown__child>ul>li');

    // Setup hover listeners for all li elements
    allLiElements.forEach(function (li) {
        setupHoverListeners(li, li.classList.contains('has--children')); // Check if it's an li with .has--children
    });

    // Mouse enter and leave for header search div
    setupHoverListeners(headerSearchDiv, false); // false indicates it's the search div

    function setupHoverListeners(element, isLiElementWithChildren) {
        element.addEventListener('mouseenter', function () {
            element.classList.add('is--active');
            headerElement.classList.add('is--active'); // Add is--active class to header
            if (isLiElementWithChildren) {
                updateDropdownAndAria(element, true); // Only for li elements with .has--children
            } else if (!element.classList.contains('header__search')) {
                // This condition prevents toggling dropdown for li elements without .has--children
                toggleDropdownShow(element, false); // Do not show dropdown for li without .has--children
            } else {
                toggleDropdownShow(element, true); // For header search div
            }
        });

        element.addEventListener('mouseleave', function () {
            element.classList.remove('is--active');
            headerElement.classList.remove('is--active'); // Remove is--active class from header
            if (isLiElementWithChildren) {
                updateDropdownAndAria(element, false); // Only for li elements with .has--children
            } else if (!element.classList.contains('header__search')) {
                // No action needed for li elements without .has--children on mouse leave
            } else {
                toggleDropdownShow(element, false); // For header search div
            }
        });
    }

    function updateDropdownAndAria(li, isActive) {
        var link = li.querySelector('a');
        var dropdown = li.querySelector('.dropdown');
        // Update the aria-expanded attribute based on the isActive parameter
        if (link) { // Ensure the element exists to avoid errors
            link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
        // Toggle the dropdown--show class on the dropdown based on the isActive parameter
        if (dropdown) { // Check if dropdown exists for li with .has--children
            toggleDropdownShow(li, isActive);
        }
    }

    function toggleDropdownShow(element, isActive) {
        var dropdown = element.querySelector('.dropdown');
        if (dropdown) { // Ensure the dropdown exists to avoid errors
            if (isActive) {
                dropdown.classList.add('dropdown--show');
            } else {
                dropdown.classList.remove('dropdown--show');
            }
        }
    }

    listItems.forEach(function (li) {
        li.addEventListener('click', function (event) {
            // Check if the clicked li has the 'has--children' class
            if (li.classList.contains('has--children')) {
                //event.preventDefault(); // Prevent default anchor action
                
                // Remove 'dropdown__child--show' and 'active-child' from any previously active items
                document.querySelectorAll('.dropdown__child--show').forEach(function (dropdown) {
                    dropdown.classList.remove('dropdown__child--show');
                });
                document.querySelectorAll('.active-child').forEach(function (activeLi) {
                    activeLi.classList.remove('active-child');
                });

                // Add 'active-child' to the clicked li
                li.classList.add('active-child');

                // Show the dropdown for the clicked li
                var dropdown = li.querySelector('.dropdown__child');
                if (dropdown) {
                    dropdown.classList.add('dropdown__child--show');
                }
            } else {
                // For li without 'has--children', remove 'active-child' and 'dropdown__child--show'
                document.querySelectorAll('.active-child').forEach(function (activeLi) {
                    activeLi.classList.remove('active-child');
                });
                document.querySelectorAll('.dropdown__child--show').forEach(function (dropdown) {
                    dropdown.classList.remove('dropdown__child--show');
                });
            }
        });
    });

    // adds "is--current" class on current page or parent page in nav
    const currentPageUrl = window.location.href;
    const navLinks = document.querySelectorAll('nav[role="navigation"] a[href]');

    navLinks.forEach(link => {
        if (link.href === currentPageUrl) {
            let li = link.closest('li');
            // Add 'is--current' to the matched link's <li> and all ancestor <li>s within the navigation
            while (li && li.tagName === 'LI') {
                li.classList.add('is--current');
                li = li.parentElement.closest('li');
            }
            // Assuming only one link can be the current page, so we stop after finding the match
            return;
        }
    });
    
    // close button behavior
    document.querySelectorAll('.dropdown__close button.close').forEach(function(button) {
        button.addEventListener('click', function() {
            // Find the closest parent <li> with .has--children
            var topLi = button.closest('li.has--children');
            // Remove the 'is--active' class from the <header>
            headerElement.classList.remove('is--active');
            // Remove the 'is--active' class from the top <li>
            if (topLi) {
                topLi.classList.remove('is--active');
                // Find the .dropdown within this <li> and hide it
                var dropdown = topLi.querySelector('.dropdown');
                if (dropdown) {
                    dropdown.classList.remove('dropdown--show');
                }
            }
        });
    });
}
});

// MOBILE NAV
document.addEventListener('DOMContentLoaded', function() {
    if (body.classList.contains('is--mobile')) {
        var mobileHeader = document.querySelector('.header');
        var mobileToggle = document.querySelector('.header__mobiletoggle button');
        var mobileNav = document.querySelector('.header__navigation');

        var mobileLanguage = document.querySelector('.header__language--mobile');
        var dropdownLanguage = document.querySelector('.header__language--mobile .dropdown');

        var mobileSearch = document.querySelector('.is--mobile .header__search');
        var dropdownSearch = document.querySelector('.is--mobile .header__search .dropdown');

        mobileToggle.addEventListener('click', function(event) {
            event.preventDefault();
            mobileHeader.classList.toggle('is--active');
            mobileNav.classList.toggle('header__navigation--mobile');

            if(mobileSearch.classList.contains('is--active')) {
                mobileSearch.classList.remove('is--active');
            }
            if(mobileLanguage.classList.contains('is--active')) {
                mobileLanguage.classList.remove('is--active');
            }
            if (dropdownLanguage && dropdownLanguage.classList.contains('dropdown--show')) {
                dropdownLanguage.classList.remove('dropdown--show');
            }
        });

        // language mobile nav
        mobileLanguage.addEventListener('click', function(event) {
            mobileHeader.classList.toggle('is--active');
            mobileLanguage.classList.toggle('is--active');
                    
            // Toggle 'dropdown--show' class based on the presence of 'is--active' on the link
            if (this.classList.contains('is--active')) {
                if (dropdownLanguage && !dropdownLanguage.classList.contains('dropdown--show')) {
                    dropdownLanguage.classList.add('dropdown--show');
                }
            } else {
                if (dropdownLanguage && dropdownLanguage.classList.contains('dropdown--show')) {
                    dropdownLanguage.classList.remove('dropdown--show');
                }
            }
            if(mobileSearch.classList.contains('is--active')) {
                mobileSearch.classList.remove('is--active');
            }
            if(mobileNav.classList.contains('header__navigation--mobile')) {
                mobileNav.classList.remove('header__navigation--mobile');
            }
        });

        // search mobile nav
        mobileSearch.addEventListener('click', function(event) {

            mobileHeader.classList.toggle('is--active');
            mobileSearch.classList.toggle('is--active');
                        
            // Toggle 'dropdown--show' class based on the presence of 'is--active' on the link
            if (this.classList.contains('is--active')) {
                if (dropdownSearch && !dropdownSearch.classList.contains('dropdown--show')) {
                    dropdownSearch.classList.add('dropdown--show');
                }
            } else {
                if (dropdownSearch && dropdownSearch.classList.contains('dropdown--show')) {
                    dropdownSearch.classList.remove('dropdown--show');
                }
            }
            if(mobileNav.classList.contains('header__navigation--mobile')) {
                mobileNav.classList.remove('header__navigation--mobile');
            }
            if(mobileLanguage.classList.contains('is--active')) {
                mobileLanguage.classList.remove('is--active');
            }
            if (dropdownLanguage && dropdownLanguage.classList.contains('dropdown--show')) {
                dropdownLanguage.classList.remove('dropdown--show');
            }
        });

        // don't close search tab on click
        document.querySelectorAll('.header__search .dropdown').forEach(dropdown => {
            dropdown.addEventListener('click', function(e) {
                e.stopPropagation(); 
            });
        });

        const headerNavigationLinks = document.querySelectorAll('.header__navigation .has--children > a');
        const navigationBack = document.querySelector('.navigation-back');
        let navigationHistory = [{ name: 'Sucden', url: '/', clickable: false }];

        function updateNavigationBack() {
            navigationBack.innerHTML = ''; // Réinitialise le contenu de navigationBack
            navigationHistory.forEach((item, index) => {
                const link = document.createElement('a');
                link.href = item.url;
                link.textContent = item.name;
                if (index === 0) {
                    link.className = 'nav-home';
                }
                if (index < navigationHistory.length - 1) {
                    link.classList.add('nav--back');
                }
                link.addEventListener('click', function(e) {
                    if (!item.clickable || index < navigationHistory.length - 1) {
                        e.preventDefault();
                        navigationHistory = navigationHistory.slice(0, index + 1);
                        updateNavigationBack();
                        removeActiveClasses(index);
                        setActiveClasses(index);
                    }
                });
                navigationBack.appendChild(link);
            });
        }

        function removeActiveClasses(currentIndex) {
            document.querySelectorAll('.is--active').forEach(link => link.classList.remove('is--active'));
            document.querySelectorAll('.dropdown--show').forEach(dropdown => dropdown.classList.remove('dropdown--show'));
        }

        function setActiveClasses(currentIndex) {
            if (currentIndex >= 0) {
                // Trouve le lien actif basé sur l'URL de l'historique
                const url = navigationHistory[currentIndex].url;
                const activeLink = Array.from(headerNavigationLinks).find(link => link.href.endsWith(url));
                if (activeLink) {
                    activeLink.classList.add('is--active');
                    const dropdown = activeLink.closest('.has--children').querySelector('.dropdown');
                    if (dropdown) {
                        dropdown.classList.add('dropdown--show');
                    }
                }
            }
        }

        headerNavigationLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const isActive = this.classList.toggle('is--active');
                const parentLi = this.closest('.has--children');
                const dropdown = parentLi.querySelector('.dropdown') || this.nextElementSibling;
                dropdown && dropdown.classList.toggle('dropdown--show', isActive);

                if (isActive) {
                    const name = this.textContent.trim();
                    const url = this.getAttribute('href');
                    const existsInHistory = navigationHistory.some(item => item.url === url);
                    if (!existsInHistory) {
                        navigationHistory.push({ name, url, clickable: true });
                        updateNavigationBack();
                    }
                }
            });
        });

        updateNavigationBack();
    }
});

// clear dropdown--show classes if we go back to the first element in "navigation-back"
function clearDropdowns() {
    document.querySelectorAll('.dropdown--show').forEach(dropdown => {
        dropdown.classList.remove('dropdown--show');
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const navigationBack = document.querySelector('.navigation-back');
    let navigationHistory = [{ name: 'Sucden', url: '/', clickable: false }];

    navigationBack.addEventListener('click', function(e) {
        const target = e.target.closest('a');
        if (target && target.classList.contains('nav-home')) {
            e.preventDefault(); // disable default nav
            navigationHistory = [{ name: 'Sucden', url: '/', clickable: false }]; // reset nav history
            updateNavigationBack(); // updates navigation-back links
            clearDropdowns(); // delete active dropdowns
        }
    });

    function updateNavigationBack() {
        navigationBack.innerHTML = ''; // Efface les liens existants
        navigationHistory.forEach((item, index) => {
            const link = document.createElement('a');
            link.href = item.url;
            link.textContent = item.name;
            link.className = (index === 0) ? 'nav-home' : 'nav--back';
            navigationBack.appendChild(link);
        });
    }

    updateNavigationBack(); // Initialise la navigation-back au chargement
});

// HERO SCROLL BUTTON
if($('body').hasClass('page-template-hub-page') || $('body').hasClass('home')) {
    document.addEventListener('DOMContentLoaded', function() {
        // Find the button inside the .hero__scroll div
        var scrollButton = document.querySelector('.hero__scroll button');

        // Add a click event listener to the button
        scrollButton.addEventListener('click', function() {
            var heroDiv = document.querySelector('.hero');
            var heroBottom = heroDiv.offsetTop + heroDiv.offsetHeight;
            var scrollToPosition = heroBottom - 75;

            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth' // Optional: Adds a smooth scrolling effect
            });
        });
    });
}

// HERO CAROUSEL HOME PAGE
if (document.getElementsByClassName("hero__carousel-home").length > 0) {
    $(".hero__carousel-home").on('init', function(event, slick){
        // Loop through each dot
        $('.slick-dots li').each(function(index){
            // Get the slide's title using the slide index
            // Note: Adjust the selector based on your actual DOM structure if needed
            var slideTitle = $('.hero__carousel-home .hero__slide').eq(index).find('h1').text();
            var slideNumber = index + 1; // Slide number (1-based index)

            // Append the span element with slide number and title
            $(this).find('button').after('<span><strong>' + String("0" + slideNumber).slice(-2) + '</strong>' + slideTitle + '</span>');
        });
    }).slick({
        arrows: !0,
        dots: !0,
        fade: !0,
        autoplay: !0,
        autoplaySpeed: 5e3,
        pauseOnHover: !1,
        responsive: [{
            breakpoint: 600,
            settings: {
                arrows: !1
            }
        }]
    });
}

// HERO PHOTO GALLERY CAROUSEL
if (document.getElementsByClassName("hero__carousel-fade").length > 0) {
    $(".hero__carousel-fade").slick({
        fade: !0,
        arrows: !1,
        autoplay: !0,
        autoplaySpeed: 2e3,
        cssEase: "ease-out",
        pauseOnHover: !1
    })
}

// MIXED CONTENT CAROUSEL
if (document.getElementsByClassName("carousel__standard").length > 0) {
    $('.carousel__standard').slick({
        arrows: !0,
        dots: !0,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 980,
            settings: {
                centerMode: !0,
                centerPadding: "20px",
                arrows: !1,
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: !0
            }
        }, {
            breakpoint: 600,
            settings: {
                centerMode: !0,
                centerPadding: "30px",
                arrows: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0
            }
        }]
    });
}

// FACTS CAROUSEL
if (document.getElementsByClassName("carousel__fade").length > 0) {
    // Initialiser chaque carousel individuellement
    $(".carousel__fade").each(function() {
        let slides_nb;

        // Vérifiez si cet élément a l'ID "facts_HR"
        if ($(this).attr('id') === "facts_HR") {
            slides_nb = 3;
        } else {
            slides_nb = 2;
        }

        $(this).slick({
            dots: true,
            slidesToShow: slides_nb,
            slidesToScroll: slides_nb,
            responsive: [{
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    });
}

// SUCDEN LIFE CAROUSEL
if (document.getElementsByClassName("carousel__simple").length > 0) {
    $(".carousel__simple").each(function() {
        let slides_nb;

        // Vérifiez si cet élément a l'ID "facts_HR"
        if ($(this).attr('id') === "peopleCarousel") {
            slides_nb = 3;
        } else {
            slides_nb = 4;
        }

        $(this).slick({
            dots: true,
            slidesToShow: slides_nb,
            slidesToScroll: slides_nb,
            responsive: [{
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    });
}

// BACK TO TOP BUTTON
$(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();
    var footerTop = $('footer').offset().top;
    var windowHeight = $(window).height();
    var footerVisibleStart = footerTop - windowHeight;

    // Check if the page is scrolled down more than 150px
    if (scrollTop >= 150) {
        $('.back-to-top').addClass('back-to-top--show');
    } else {
        $('.back-to-top').removeClass('back-to-top--show');
    }

    // Check if the footer is visible in the viewport
    if (scrollTop >= footerVisibleStart) {
        $('.back-to-top').addClass('back-to-top--fixed');
    } else {
        $('.back-to-top').removeClass('back-to-top--fixed');
    }
});

$('.back-to-top').on('click', function() { 
	$('body,html').animate({
    	scrollTop : 0 
    }, 1000); // Speed 
});

// SHARE BUTTON BEHAVIOR
if ($('body').hasClass('page-template-default') || $('body').hasClass('page-template-page-modules') || $('body').hasClass('page-template-service') || $('body').hasClass('page-template-search')) {
    var shareLink = document.querySelector('.share .btn a');

    shareLink.addEventListener('click', function(event) {
        event.preventDefault();
        var shareDiv = document.querySelector('.share');
        shareDiv.classList.toggle('is--active');
    });
}

// AREA BLOCK CLICK
if($('body').hasClass('page-id-90') || $('body').hasClass('page-id-1659') || $('body').hasClass('page-id-1946') ) {
    var areaBlock = document.querySelectorAll('.sdg-area__header');

    areaBlock.forEach(function(element) {
        element.addEventListener('click', function() {
            // Check if the clicked element already has the 'is--active' class
            var isActive = this.classList.contains('is--active');
            
            // First, remove 'is--active' class from all elements
            areaBlock.forEach(function(el) {
                el.classList.remove('is--active');
            });
            
            // Then, if the clicked element was not already active, add 'is--active' class to it
            if (!isActive) {
                this.classList.add('is--active');
            }
        });
    });    
}

// BOARD MEMBERS PROFILE BOXES
document.addEventListener('DOMContentLoaded', function() {
    // Shows a specific profile based on its element
    function showProfile(profileSingle) {
        profileSingle.classList.add('profile-single--show');
    }

    // Hides the currently visible profile
    function hideProfile() {
        document.querySelectorAll('.profile-single--show').forEach(function(profile) {
            profile.classList.remove('profile-single--show');
        });
    }

    // Event listeners for the profile links
    document.querySelectorAll('.flex__item .block--profile').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            hideProfile();
            var currentItem = link.closest('.flex__item');
            var profileSingle = currentItem.nextElementSibling;
            showProfile(profileSingle);
        });
    });

    // Event listeners for closing the profile
    document.querySelectorAll('.pagination__close a').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            hideProfile();
        });
    });
});

// ACCORDION BEHAVIOR
if($('body').hasClass('page-template-contact')) {
    document.addEventListener('DOMContentLoaded', function () {
        const updateButtonText = (button) => { // updating the text in button span
            const ariaExpanded = button.getAttribute('aria-expanded');
            const span = button.querySelector('span');
            span.textContent = ariaExpanded === 'true' ? translatedVar.close : translatedVar.open;
        };

        const buttons = document.querySelectorAll('.accordion__header');
        buttons.forEach(button => {
            updateButtonText(button); // Update button text on page load
            button.addEventListener('click', () => updateButtonText(button)); // and on click
        });

        const toggleButton = document.getElementById('openAllAccordions');
        const accordionItems = document.querySelectorAll('.accordion-item');

        toggleButton.addEventListener('click', function() {
            const isOpening = toggleButton.textContent.includes(translatedVar.open);

            accordionItems.forEach(item => {
                const headerButton = item.querySelector('.accordion__header');
                const spanButton = headerButton.querySelector('span');
                const collapseElement = item.querySelector('.accordion-collapse');

                if (isOpening) {
                    // Pour ouvrir
                    headerButton.classList.remove('collapsed');
                    headerButton.setAttribute('aria-expanded', 'true');
                    collapseElement.classList.add('show');
                    spanButton.textContent = translatedVar.close;
                    item.classList.add('collapsed'); // Assurez-vous que la classe est retirée quand c'est ouvert
                } else {
                    // Pour fermer
                    headerButton.classList.add('collapsed');
                    headerButton.setAttribute('aria-expanded', 'false');
                    collapseElement.classList.remove('show');
                    spanButton.textContent = translatedVar.open;
                    item.classList.remove('collapsed'); // Ajouter la classe collapsed à l'item
                }
            });

            // Mettre à jour le texte du bouton basé sur l'action effectuée
            toggleButton.textContent = isOpening ? translatedVar.close_all : translatedVar.open_all;
        });

        // Initialize on page load
        updateAccordionClasses();

        // Attach event listeners to accordion buttons
        document.querySelectorAll('.accordion__header').forEach(button => {
            button.addEventListener('click', function () {
                // Wait for the collapse animation to complete before toggling the class
                setTimeout(updateAccordionClasses, 350);
            });
        });

        function updateAccordionClasses() {
            document.querySelectorAll('.accordion-item').forEach(item => {
                const button = item.querySelector('.accordion__header');
                if (button.getAttribute('aria-expanded') === 'false') {
                    item.classList.remove('collapsed');
                } else {
                    item.classList.add('collapsed');
                }
            });
        }
    });
}

// ANIMATE CLASS ON HERO
document.addEventListener('DOMContentLoaded', (event) => {
    if (document.getElementsByClassName("hero").length > 0) {
        document.querySelector('.hero').classList.add('animate');
    }

    if (document.getElementsByClassName("hero--map").length > 0) { // no animate behahior if we use the map hero
        document.querySelector('.hero').classList.remove('animate');
    }
});

// MAP
if (document.getElementsByClassName("hero-map-instruct").length > 0) {

    var mapInstructions = document.getElementsByClassName("hero-map-instruct")[0];
    mapInstructions.style.display = "block";
    mapInstructions.className += " animate js-animate";
    
    setTimeout(function() {
        mapInstructions.classList.remove("js-animate");
    }, 1000);
}

// FACETWP NEWS FILTER
if (document.getElementsByClassName("blog").length > 0) {
    (function($) {
        $(document).on('facetwp-loaded', function() {
            var totalResults = FWP.settings.pager.total_rows; // Total number of results
            var perPage = FWP.settings.pager.per_page; // Results per page
            var loadedResults = FWP.loaded ? (FWP.settings.pager.page * perPage) : perPage; // Results currently displayed
    
            // If the number of loaded results exceeds total results (can happen with the last page)
            loadedResults = (loadedResults > totalResults) ? totalResults : loadedResults;
    
            // Update the counts display
            var displayText = translatedVar.displaying + loadedResults + translatedVar.of + totalResults;
            $('.filter-header__info').text(displayText);
        });
    })(jQuery);

    (function($) {
        $(document).on('facetwp-loaded', function() {
            if ('undefined' !== typeof FWP.facets.date_year) {
                var options = $('.facetwp-facet-date_year .facetwp-dropdown').find('option');
                options.sort(function(a, b) {
                    return b.value - a.value; // Reverse numerical sort
                });
                $('.facetwp-facet-date_year .facetwp-dropdown').empty().append(options);
                //FWP.facets['date_year'](); // Re-initialize the fSelect dropdown
            }
        });
    })(jQuery);
}

if (document.getElementsByClassName("page-template-search").length > 0) {
    (function($) {
        $(document).on('facetwp-loaded', function() {
            var totalResults = FWP.settings.pager.total_rows; // Total number of results
            var perPage = FWP.settings.pager.per_page; // Results per page
            var loadedResults = FWP.loaded ? (FWP.settings.pager.page * perPage) : perPage; // Results currently displayed
    
            // If the number of loaded results exceeds total results (can happen with the last page)
            loadedResults = (loadedResults > totalResults) ? totalResults : loadedResults;
    
            // Update the counts display
            var displayText = translatedVar.displaying + loadedResults + translatedVar.of + totalResults;
            $('.filter-header__info').text(displayText);
        });
    })(jQuery);
}

if (document.getElementsByClassName("page-template-search").length > 0) {
    $('.facetwp-template').addClass('results');
}

// MISC JQUERY
if($('body').hasClass('page-template-page-modules')) {
    $('.wp-block-group.alignfull').addClass('module');
    $('.wp-block-group__inner-container').addClass('container').removeClass('wp-block-group__inner-container');
    $('.wp-block-group.alignfull .container').wrapInner( "<div class='editor'></div>");
    $('figure figcaption').wrapInner( "<p></p>");
    $('.wp-block-group.alignfull.module--push .container').addClass('container--flex').addClass('container--push');
    $('.wp-block-group.alignfull.module--infoblock .container').addClass('container--flex').addClass('container--push');
}

if (!document.body.classList.contains('home')) {
var span = document.querySelector('.breadcrumb-item.active');
    if (span) {
        var text = span.textContent;
        var words = text.split(' ');
        if (words.length > 10) {
            var first15Words = words.slice(0, 10).join(' ');
            first15Words += '...';
            span.textContent = first15Words;
        }
    }
}